import { Component, OnInit } from '@angular/core';

import {
  ClosableModalWithErrorResponseModel
} from '../../shared/components/base/closable-modal-with-error-response-model';

import { NotificationService, AllEvaluationMethodService } from '../../shared/services';
import { ModalService } from '../../shared/modules/modal';
import {
  TransactionNotAppliedMethodEvaluationModalPayload,
  MethodEvaluationErrorResponse
} from '../../shared/models';

import { TinyTextEditor } from '../../shared/constants';

@Component({
  selector: 'transaction-na-method-evaluation-modal',
  templateUrl: './transaction-na-method-evaluation-modal.component.html',
})
export class TransactionNotAppliedMethodEvaluationModalComponent
  extends ClosableModalWithErrorResponseModel<MethodEvaluationErrorResponse>
  implements OnInit {

  data: TransactionNotAppliedMethodEvaluationModalPayload;

  tinyInit = TinyTextEditor.INIT;

  constructor(
    protected notificationService: NotificationService,
    protected modalService: ModalService,
    private _allMethodEvaluationService: AllEvaluationMethodService
  ) {
    super(notificationService, modalService);
  }

  ngOnInit(): void {
    this.listenForErrorMessages();
  }

  save(): void {
    if (this.isSaveDisabled) {
      return;
    }

    this.isSaveDisabled = true;

    this._allMethodEvaluationService
      .saveNotAppliedEvaluationMethodDiscussion(this.data.transactionId, this.data.methodEvaluation)
      .subscribe(() => {
        this.success();
        this.closeAllModals();
      });
  }
}
